__turbopack_context__.v({
  "appliedServiceItem": "applied-service-item-module-scss-module__GQu04G__appliedServiceItem",
  "image": "applied-service-item-module-scss-module__GQu04G__image",
  "mobileAlign": "applied-service-item-module-scss-module__GQu04G__mobileAlign",
  "price": "applied-service-item-module-scss-module__GQu04G__price",
  "removeButton": "applied-service-item-module-scss-module__GQu04G__removeButton",
  "title": "applied-service-item-module-scss-module__GQu04G__title",
});
